export function arraymove(arr, fromIndex, toIndex) {
  const element = arr[fromIndex];
  arr.splice(fromIndex, 1);
  arr.splice(toIndex, 0, element);
}

export const renameFile = (originalFile, newName) => new File([originalFile], newName, { type: originalFile.type, lastModified: originalFile.lastModified });
